import styles from "./EmptyState.module.css";
import { Button, Text } from "@zapier/design-system";

export const EmptyState = () => {
  return (
    <section className={styles.wrapper}>
      <Text type="subHeader5" tag="h2">
        No templates found
      </Text>
      <Button
        color="primary-alt"
        size="small"
        target="_blank"
        href="https://template-request.zapier.app"
      >
        Request a template
      </Button>
    </section>
  );
};
